import { Payment as GQLPayment, PaymentTypeEnum } from '../../generated/graphql';

export const PaymentType = Object.freeze({
  CASH: PaymentTypeEnum.Cash,
  CHECK: PaymentTypeEnum.Check,
  CREDIT_CARD: PaymentTypeEnum.CreditCard,
  NONE: PaymentTypeEnum.None,
  WIRE_TRANSFER: PaymentTypeEnum.WireTransfer,
});

export type PaymentType = (typeof PaymentType)[keyof typeof PaymentType];

export type SettlementAttachment = {
  id: number;
  identifier: string;
  url: string;
};

export type Payment = {
  id: number;
  _destroy?: boolean | null;
  amount?: number | null;
  checkWireNr?: string | null;
  dateDue?: string | null;
  datePaid?: string | null;
  description?: string | null;
  paymentType?: PaymentType | null;
  attachments?: SettlementAttachment[] | null;
};

export const fromGql = (item: GQLPayment): Payment => ({
  id: item.id,
  _destroy: item._destroy ?? null,
  amount: item.amount ?? null,
  checkWireNr: item.checkWireNr ?? null,
  dateDue: item.dateDue ?? null,
  datePaid: item.datePaid ?? null,
  description: item.description ?? null,
  paymentType: (item.paymentType ?? null) as PaymentType | null,
  attachments: item.attachments
    ?.filter(att => att.id != null && att.identifier != null && att.url != null)
    .map(att => ({ id: att.id!, identifier: att.identifier!, url: att.url! })) ?? null,
});
